<template>
  <div>
    <Head title="Prüfungssimulation" />
    <exam :exam="exam" :test="test" :start-index="index" :free-control-data="freeControlData"></exam>
  </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
// import LoadingButton from '../../Shared/LoadingButton'
import Exam from '@/Shared/Exam/Exam'

export default {
  components: {
    // LoadingButton,
    Head,
    Exam,
  },

  layout: Layout,

  props: {
    exam: Object,
    test: Object,
    index: Number,
    // eslint-disable-next-line vue/prop-name-casing
    freeControlData: {
      type: Array,
      required: false,
    }
  },

  data() {
    return {
      isLoading: false,
    }
  },

  methods: {},
}
</script>
